/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { goodLuckCoreEntitiesDraftPlayerSchema } from "./draftPlayerSchema.ts";
import { goodLuckCoreEntitiesDraftTeamMemberSchema } from "./draftTeamMemberSchema.ts";
import { goodLuckCoreEntitiesDraftTeamStatusSchema } from "./draftTeamStatusSchema.ts";
import { goodLuckCoreEntitiesTournamentSchema } from "./tournamentSchema.ts";
import { goodLuckCoreEntitiesUserSchema } from "./userSchema.ts";
import { z } from "zod/v4";

export const goodLuckCoreEntitiesDraftTeamSchema = z.object({
  id: z.string().nullish(),
  tournamentId: z.string().nullish(),
  captainId: z.string().nullish(),
  name: z.string().min(1),
  initialBudget: z.optional(z.int()),
  remainingBudget: z.optional(z.int()),
  playersSelected: z.optional(z.int()),
  maxPlayers: z.optional(z.int()),
  get status() {
    return goodLuckCoreEntitiesDraftTeamStatusSchema.optional();
  },
  draftOrder: z.optional(z.int()),
  isCurrentlyPicking: z.optional(z.boolean()),
  lastPickTime: z.iso.datetime().nullish(),
  createdAt: z.optional(z.iso.datetime()),
  get tournament() {
    return goodLuckCoreEntitiesTournamentSchema.optional();
  },
  get captain() {
    return goodLuckCoreEntitiesUserSchema.optional();
  },
  get members() {
    return z.array(goodLuckCoreEntitiesDraftTeamMemberSchema).nullish();
  },
  get selectedPlayers() {
    return z.array(goodLuckCoreEntitiesDraftPlayerSchema).nullish();
  },
});
